<template>
  <v-card
    v-show="isVisible"
    :class="['mt5-cta', { 'mt5-cta-shown': isShown }]"
    elevation="5"
    color="darkGreen"
  >
    <v-card-title class="white--text" style="font-family: 'Aeonik'; font-weight: 700;">
      <v-icon color="white" class="mr-2">fa-sync-alt</v-icon>
      {{ $t('mt5Cta.title') }}
    </v-card-title>
    <v-card-text class="white--text" style="font-family: 'Avenir';">
      {{ $t('mt5Cta.description') }}
      
      <v-checkbox
        v-model="dontShowAgain"
        :label="$t('mt5Cta.dontShowAgain')"
        color="white"
        class="mt-3 white--text"
        hide-details
        dense
      ></v-checkbox>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="white"
        text
        @click="dismissNotification"
      >
        {{ $t('mt5Cta.dismiss') }}
      </v-btn>
      <v-btn
        color="accent"
        @click="goToMT5Connect"
      >
        {{ $t('mt5Cta.cta') }}
        <v-icon small class="ml-1">fa-external-link-alt</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'MT5AutoSyncCTA',
  data() {
    return {
      isVisible: false,
      isShown: false,
      dontShowAgain: false
    }
  },
  mounted() {
    // Check if the user has previously chosen not to see this notification
    const hideNotification = localStorage.getItem('hideMT5AutoSyncCTA') === 'true';
    
    if (!hideNotification) {
      // Show the CTA after a small delay for better UX
      setTimeout(() => {
        this.isVisible = true
        // Apply the shown class after a brief moment to trigger animation
        setTimeout(() => {
          this.isShown = true
        }, 100)
      }, 1500)
    }
  },
  methods: {
    dismissNotification() {
      this.isVisible = false
      
      // If "don't show again" is checked, save to localStorage
      if (this.dontShowAgain) {
        localStorage.setItem('hideMT5AutoSyncCTA', 'true')
      }
    },
    goToMT5Connect() {
      // If "don't show again" is checked, save to localStorage even when clicking the CTA
      if (this.dontShowAgain) {
        localStorage.setItem('hideMT5AutoSyncCTA', 'true')
      }
      
      this.$router.push('/connect-metatrader')
    }
  }
}
</script>

<style scoped>
.mt5-cta {
  position: fixed;
  bottom: 30px;
  left: -350px;
  width: 350px;
  z-index: 100;
  border-radius: 8px;
  transition: transform 0.6s cubic-bezier(0.2, 0.9, 0.3, 1.5);
  transform: translateX(0);
  overflow: hidden;
}

.mt5-cta-shown {
  transform: translateX(430px);
}

.mt5-cta::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
}

/* Style the checkbox label to be white and 14px */
::v-deep .v-label {
  color: white !important;
  font-size: 14px !important;
}
</style>


